import { render } from "./HeroiconsSolidCurrencyDollar.vue?vue&type=template&id=6096326e"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCurrencyDollar.vue"]])

export default __exports__